export const en = {
  newTag: 'New tag',
  tags: 'TAGS:',
  wentWrong: 'Something went wrong, please try again.'
};

export type Translations = typeof en;
